import {getClientsList, getInactiveMembers, getUnapprovedMembers} from '@/api/studioServices'


export const pagination = {
    state: {
        tableData: {},
    },
    actions: {
        async PAGINATE({commit}, payload) {
            commit('SET_LOADER', true);
            const { page, requestFunction, options = null} = payload;


            try {
                let response;


                if (options) {
                    response = await requestFunction({page, ...options});
                } else {
                    response = await requestFunction(page);
                }

                const data = response.data.data;
                const key = Object.keys(data)[0];
                commit('SET_TABLE_DATA', data[key]);
                commit('SET_LOADER', false);
                return response;
            }catch(e) {
                console.log(e)
            }
        },
        STUDIO_REFRESH_CLIENTS_TABLE({state, dispatch}) {
            const {current_page, path} = state.tableData;
            const pathSplit = path.split('/');
            const lastSegment = pathSplit[pathSplit.length - 1];


            let page, requestFunction = null;

            page = current_page
            if(current_page > 1) {
                let dataLength = state.tableData.data.length;
                if(dataLength === 1) {
                    page = current_page - 1
                }
            }
            if(lastSegment === 'inactive') {
                requestFunction = getInactiveMembers
            } else if(lastSegment === 'client'){
                requestFunction = getClientsList
            } else if(lastSegment === 'unverified'){
                requestFunction = getUnapprovedMembers
            }

            dispatch('PAGINATE', {page: page, requestFunction: requestFunction})
        },


    },
    mutations: {
        SET_TABLE_DATA(state, newTableData) {
            state.tableData = {...newTableData};
        },
        UNSET_TABLE_DATA(state) {
            state.tableData = {}
        }
    },
    getters: {
        tableData: state => state.tableData,
    }
};